// src/components/common/StickyQuoteCTA.jsx
import React from "react";
import { Link } from "react-router-dom";

const ORANGE = "#F27E33";
const NAVY   = "#1D2946";

const StickyQuoteCTA = ({ selectedServices = [] }) => {
  return (
    <div className="sticky bottom-4 z-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="
            rounded-2xl border border-white/15 bg-white/10 backdrop-blur-md 
            px-5 py-4 flex flex-col sm:flex-row gap-3 sm:gap-4 items-center justify-between
          ">
          <p className="text-white/90 text-sm text-center sm:text-left">
            {selectedServices.length > 0
              ? `Listo para cotizar ${selectedServices.length} servicio(s)?`
              : "¿Listo para cotizar tu proyecto?"}
          </p>

          {/* Botón SIRECC */}
          <Link
            to="/contact-quote-request"
            className="
              group relative inline-flex items-center justify-center
              w-full sm:w-auto
              rounded-xl px-5 py-2.5 font-semibold
              text-white
              shadow-[0_6px_24px_rgba(242,126,51,0.35)]
              ring-1 ring-white/10
              transition-all duration-300
              hover:shadow-[0_8px_28px_rgba(242,126,51,0.45)]
              hover:-translate-y-[1px] active:translate-y-[0px]
              focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-0
            "
            style={{
              background: `linear-gradient(135deg, ${ORANGE} 0%, #ff9450 40%, ${ORANGE} 100%)`,
            }}
          >
            <span className="relative z-10">Solicitar Cotización</span>
            {/* borde fino en navy para integrar la marca */}
            <span
              className="absolute inset-0 rounded-xl pointer-events-none"
              style={{ boxShadow: `inset 0 0 0 1px ${NAVY}55` }}
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StickyQuoteCTA;
